import { ConnectedHTMLElement } from "./ConnectedHtmlElement.js";
import { DispatchAction } from "../state/State.js";
import { GameActions } from "../state/GameReducer.js";

/**
 * @name BaseEpicAction
 * @class BaseEpicAction
 * @extends {ConnectedHTMLElement}
 * @description
 *
 */
export class BaseEpicAction extends ConnectedHTMLElement {
  static observedAttributes = ["player"];

  constructor() {
    super();
  }

  /**
   * @param {SwucState} newState
   * @param {SwucState} oldState
   */
  stateUpdated(newState, oldState) {
    const player = this.getAttribute("player");
    const button = this.querySelector("#epic-action-btn");
    if (!button) {
      return;
    }

    //player has used their epic action
    if (
      newState[player].hasUsedEpicAction !== oldState[player].hasUsedEpicAction
    ) {
      button.classList.remove("opacity-50");
    }
    // New game is on, remove hidden
    if (
      oldState.currentGame === undefined &&
      newState.currentGame !== undefined
    ) {
      button.classList.add("opacity-50");
      button.classList.remove("hidden");
    }
    // Rematch, remove hidden
    if (
      oldState.currentGame !== undefined &&
      oldState.currentGame.ended === true &&
      newState.currentGame !== undefined &&
      newState.currentGame.ended === false
    ) {
      button.classList.add("opacity-50");
      button.classList.remove("hidden");
    }
    // Game is over, add hidden
    if (
      newState.currentGame !== undefined &&
      newState.currentGame.ended === true
    ) {
      button.classList.add("hidden");
    }
  }

  registerElementEvents() {
    const player = this.getAttribute("player");
    const button = this.querySelector("button");
    button.addEventListener("click", () => {
      button.classList.add("spin");
      setTimeout(() => {
        button.classList.remove("spin");
        DispatchAction(GameActions.useEpicAction, player);
      }, 600);
    });
  }

  render() {
    const gameOver =
      this.state.currentGame !== undefined && this.state.currentGame.ended;
    if (gameOver) {
      this.innerHTML = "";
      return;
    }
    this.innerHTML = `
        <button
          class=" opacity-50 absolute right-[10px] bottom-[55px] z-10 bg-none border-none hidden"
          id="epic-action-btn"
        >
          <span class="hidden">Epic action</span>
          <img
            alt="Epic action"
            class=" w-[60px] h-auto"
            height="511"
            id="top-epic-action"
            loading="lazy"
            src="/assets/img/epic-action.png"
            width="410"
          />
        </button>`;
    this.registerElementEvents();
  }

  connectedCallback() {
    this.render();
  }

  dispatchEvent(event) {
    return false;
  }
}
